import PropTypes from 'prop-types';
import NextImage from 'next/image';
import RawHtml from '../RawHtml/RawHtml';
import GlossaryText from '../GlossaryText';
import styles from './ManualHero.module.scss';

const ManualHero = ({ logo = null, title = '', image = null, intro = '' }) => {
    const hasLogo = !!logo?.url;

    if (!hasLogo && !title && !image?.url && !intro) {
        return null;
    }

    return (
        <div className={styles['ManualHero']}>
            {(hasLogo || !!title) && (
                <h1 className={styles['ManualHero__Heading']}>
                    {hasLogo ? (
                        // A plain img: next/image refuses SVG without
                        // dangerouslyAllowSVG.
                        <img
                            src={logo.url}
                            alt={title}
                            className={styles['ManualHero__Logo']}
                        />
                    ) : (
                        <GlossaryText text={title} />
                    )}
                </h1>
            )}

            {!!image?.url && (
                // No sizes: an overstated one makes the browser treat an
                // undersized source as high density and shrink it.
                <NextImage
                    src={image.url}
                    alt={image.alt || ''}
                    width={image.width}
                    height={image.height}
                    className={styles['ManualHero__Image']}
                />
            )}

            {!!intro && (
                <div className={styles['ManualHero__Intro']}>
                    <RawHtml html={intro} />
                </div>
            )}
        </div>
    );
};

ManualHero.propTypes = {
    logo: PropTypes.shape({
        url: PropTypes.string,
    }),
    title: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
    }),
    intro: PropTypes.string,
};

export default ManualHero;
